import httpRequest from './request'   //引入axios封装请求

export default{
    //get请求
	reftoken:param=>httpRequest.get('/login/refToken',param), //刷新token
	getcode:param=>httpRequest.get('/login/getCode',param), //获取邮箱验证码
	getphonecode:param=>httpRequest.get('/login/getCodeByPhone',param), //获取手机号验证码
	Configdetails:param=>httpRequest.get('/template/template',param),  //获取标准详情
	getmember:param=>httpRequest.get('/dept/list',param),  //获取组织架构
	getdistribution:(param)=>httpRequest.get('/user/queryDistribution',param),  //获取配置人员信息
	getdistributioninfo:(param)=>httpRequest.get('/user/queryDistributionInfo',param),  //获取人员信息其他信息，不传用户id默认查询当前登录用户
	getuserinfo:(param)=>httpRequest.get('/user/info',param),  //获取当前登录用户信息
	getmoudle:(param)=>httpRequest.get('/purview/menu/allMenu',param),  //获取所有模块菜单（权限）
	getjoblist:(param)=>httpRequest.get('/position/list',param),  //获取职位列表（不分页）
	
	get:(url,param,headers)=>httpRequest.get(url,param,headers), //post请求带url
	
    //post请求
	ReturnSubmit:data=>httpRequest.post('/staffAssess/returnSubmit',data),  //提交的驳回
	Login:data=>httpRequest.post('/login/password',data),  //登录
	Editpass:data=>httpRequest.post('/user/editPassword',data),  //修改密码
	Register:data=>httpRequest.post('/login/register',data),  //注册
	Logout:data=>httpRequest.post('/login/logout',data),  //退出登录
	Copytemplate:data=>httpRequest.post('/template/copy',data),  //复制模板
	Configlist:data=>httpRequest.post('/template/page',data),  //获取标准模板
	Configlistall:data=>httpRequest.post('/template/list',data),  //获取标准模板(不分页)
	Configadd:data=>httpRequest.post('/template/add',data),  //添加标准模板
	Configdel:data=>httpRequest.post('/template/del',data),  //删除标准模板
	Configadditem:data=>httpRequest.post('/template/addTemplate',data),  //新增标准项
	Configdelitem:data=>httpRequest.post('/template/delTemplate',data),  //删除标准项
	Configsave:(data,headers)=>httpRequest.post('/template/preservation',data,headers),  //保存标准
	staffsaveall:(data,headers)=>httpRequest.post('/staffAssess/conserve',data,headers),  //企业文化考核批量保存
	staffsaveitem:(data,headers)=>httpRequest.post('/staffAssess/edit',data,headers),  //企业文化考核修改单个项
	Scorelist:(data)=>httpRequest.post('/score/queryStayScore',data),  //获取待评审列表
	stafflist:(data)=>httpRequest.post('/staffAssess/page',data),  //企业文化考核列表
	staffsubmit:(data)=>httpRequest.post('/staffAssess/submit',data),  //企业文化考核提交
	staffdetails:(data)=>httpRequest.post('/staffAssess/details',data),  //企业文化考核详情
	scoredetails:(data)=>httpRequest.post('/score/queryMyScoreDetails',data),  //获取我的待评分详情(管理端)
	scoresave:(data,headers)=>httpRequest.post('/score/leaderScore',data,headers),  //保存我的待评分详情(管理端)
	scorepreview:(data)=>httpRequest.post('/score/queryMyScoreSubmitInfo',data),  //提交前的预览
	scoresecend:(data)=>httpRequest.post('/score/submitReviewerTotalScore',data),  //预览之后的提交
	allscoredetails:(data)=>httpRequest.post('/score/queryScoreDetails',data),  //获取已评分详情
	finishstaffassess:(data)=>httpRequest.post('/staffAssess/queryCompleteStaffAssess',data),  //获取完成审核的列表
	queryHistoryRecord:(data)=>httpRequest.post('/staffAssess/queryHistoryRecord',data),  //领导查询所有数据列表
	inspacetor:(data,headers)=>httpRequest.post('/staffAssessRecordInspector/saveInspector',data,headers),  //提交抽检
	deptedit:(data)=>httpRequest.post('/dept/edit',data),  //修改部门
	deptdel:(data)=>httpRequest.post('/dept/del',data),  //删除部门
	deptsave:(data)=>httpRequest.post('/dept/save',data),  //保存部门
	memberlist:(data)=>httpRequest.post('/user/page',data),  //部门成员列表
	distribution:(data,headers)=>httpRequest.post('/user/distribution',data,headers),  //配置人员信息
	jobdel:(data)=>httpRequest.post('/position/del',data),  //职位删除
	jobedit:(data)=>httpRequest.post('/position/edit',data),  //职位修改
	jobadd:(data)=>httpRequest.post('/position/save',data),  //职位添加
	userExamine:(data)=>httpRequest.post('/user/examine',data),  //审核用户
	userSave:(data)=>httpRequest.post('/user/saveUser',data),  //添加用户
	userEdit:(data)=>httpRequest.post('/user/editUser',data),  //修改用户
	userdel:(data)=>httpRequest.post('/user/del',data),  //删除用户
	lookuser:(data)=>httpRequest.post('/staffAssess/queryNotRatedCompanyCulture',data),  //查询待审核份数是哪些用户
	
	// 考核配置
	gethandletest:(param)=>httpRequest.get('/submitHandleTask/list',param), 
	savehandletest:(data)=>httpRequest.post('/submitHandleTask/save',data),
	edithandletest:(data)=>httpRequest.post('/submitHandleTask/edit',data),
	delhandletest:(data)=>httpRequest.post('/submitHandleTask/del',data),
	
	//个人统计
	mydata:(data)=>httpRequest.post('/statistics/queryPersonalScoreComparison',data),  //统计之总览
	
	//集团报表
	groupsummary:(data)=>httpRequest.post('/statistics/groupSummary',data),  //统计之总览
	groupyear:(data)=>httpRequest.post('/statistics/queryBusinessDivisionYear',data),  //年度对比总览
	groupfour:(data)=>httpRequest.post('/statistics/queryAllFourItemsByDept',data),  //月度四大类总览
	
	//地产and光谷统计报表
	statisticsfirst:(data)=>httpRequest.post('/statistics/queryStatisticalDetails',data),  //统计之总览
	statisticssecend:(data)=>httpRequest.post('/statistics/queryAverageScoreComparison',data),  //统计之月份对比
	statisticsthird:(data)=>httpRequest.post('/statistics/queryTeamMajorItems',data),  //统计之四大类
	statisticsthoused:(data)=>httpRequest.post('/statistics/queryScoreComparison',data),  //统计之20项得分
	statisticsfive:(data)=>httpRequest.post('/statistics/queryAnalysisOfExaminationResults',data),  //统计之结果分析
	
	//酒店统计报表
	hotelresult:(data)=>httpRequest.post('/statistics/hotelAssessmentResults',data),    //酒店事业部考核结果
	hotelreach:(data)=>httpRequest.post('/statistics/hotelReach',data), 				   //酒店目标达成情况分析
	hotelrank:(data)=>httpRequest.post('/statistics/hotelDirectorAssessmentResults',data), //酒店排名分析
	hoteltwo:(data)=>httpRequest.post('/statistics/hotelArrange',data), //酒店271分布
	hotelaverage:(data)=>httpRequest.post('/statistics/hotelAverageScoreComparison',data), //酒店平均分
	
	//通讯统计报表
	reportarrange:(data)=>httpRequest.post('/statistics/communicationArrange',data), //通讯事业部271排布
	reportcommuni:(data)=>httpRequest.post('/statistics/communicationAssessmentResults',data), //通讯事业部考核结果(数据总览)
	reportresults:(data)=>httpRequest.post('/statistics/communicationDirectorAssessmentResults',data), //通讯事业部考核结果排名(数据总览)
	reportteam:(data)=>httpRequest.post('/statistics/communicationTeamMajorItems',data),  //通讯四大项
	reportavage:(data)=>httpRequest.post('/statistics/funcommunicationAverageScoreComparison',data),  //通讯平均分比较
	
	//夺命连环call
	getnosubmitlist:(param)=>httpRequest.post('/staffAssess/queryUnsubmitted',param),  //获取未提交用户
	sendcode:(param)=>httpRequest.post('/staffAssess/remind',param),  //获取未提交用户
	
	rolepage:(data)=>httpRequest.post('/purview/role/queryPage',data),  //获取角色列表
	roleedit:(data)=>httpRequest.post('/purview/role/editRole',data),  //修改角色
	roledel:(data)=>httpRequest.post('/purview/role/delRole',data),  //删除角色
	rolesave:(data)=>httpRequest.post('/purview/role/saveRole',data),  //添加角色
	roleuserpage:(data)=>httpRequest.post('/purview/roleUser/queryUserByRoleId',data),  //角色用户列表
	roleuserassign:(data)=>httpRequest.post('/purview/roleUser/assignUser',data),  //角色分配用户
	roleusercancel:(data)=>httpRequest.post('/purview/roleUser/delByUserId',data),  //角色用户取消授权
	backstafflist:(data)=>httpRequest.post('/staffAssess/return',data),  //退回

	postEditAssessTime:data=>httpRequest.post('/staffAssess/editMonth',data),  //修改考核时间


	editpassword:data=>httpRequest.post('/user/sys/user/editPassword',data),  //修改密码
	
    post:(url,data,headers)=>httpRequest.post(url,data,headers), //post请求带url

}